import axios from 'axios'
import debounce from 'debounce-promise'
import React, { useCallback, useEffect, useState } from 'react'
import { API_HOST } from '../../consts'
import InputAsync from './InputAsync'

type ExamInputSelectProps = {
  collectionId: number
  onChange?: any
  label: any
  name?: string
  params?: any
  usePreSelect?:any

}

const ExamInputSelect = ({
  collectionId,
  params,
  onChange,
  label,
  name,
  usePreSelect,
}: ExamInputSelectProps) => {
  const [exams, setExams] = useState([])
  const [firstExam, setFirstExam] = useState<any>()

  // eslint-disable-next-line
  const fetchItems = useCallback(
    debounce(async (search) => {
      const url =
        `${API_HOST}/v1/exams` +
        (collectionId ? `?collection=${collectionId}` : '')
      const response = await axios.get(url, {
        // Need to change endpoint
        params: {
          search
        }
      })
      collectionId && setExams(response.data)
      if(collectionId && response.data && response.data.length > 0){
        setFirstExam(response.data[0])
      }
    }, 500),
    [collectionId]
  )

  useEffect(() => {
    fetchItems('')
  }, [collectionId, fetchItems])

  const loadOptions = async (search) => {
    await fetchItems(search)
    return exams
  }

  return (
    <InputAsync
      key={JSON.stringify({ ...params, collectionId })}
      defaultOptions={exams}
      loadOptions={loadOptions}
      name={name || 'items'}
      getOptionValue={(d) => d.id}
      getOptionLabel={(d) => d.name}
      onChange={onChange}
      label={label}
      preSelect={usePreSelect?firstExam:false}
    />
  )
}

export default ExamInputSelect
